<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      pageId: '',
      pageAccessToken: '',
      userAccessToken: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    pageId: { required },
    pageAccessToken: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      const pageToken = this.pageAccessToken.trim();
      const userToken = this.userAccessToken.trim() || pageToken;

      try {
        const inbox = await this.$store.dispatch('inboxes/createFBChannel', {
          inbox_name: this.inboxName.trim(),
          page_id: this.pageId.trim(),
          page_access_token: pageToken,
          user_access_token: userToken,
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: inbox.id,
          },
        });
      } catch (error) {
        useAlert(
          error?.response?.data?.message ||
            error?.message ||
            this.$t('INBOX_MGMT.ADD.FB.MANUAL.ERROR')
        );
      }
    },
  },
};
</script>

<template>
  <form
    class="mx-0 flex max-w-xl flex-col flex-wrap"
    @submit.prevent="createChannel()"
  >
    <div class="mb-4">
      <h2 class="text-base font-medium text-n-slate-12">
        {{ $t('INBOX_MGMT.ADD.FB.MANUAL.TITLE') }}
      </h2>
      <p class="mt-1 text-sm text-n-slate-11">
        {{ $t('INBOX_MGMT.ADD.FB.MANUAL.HELP') }}
      </p>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.FB.INBOX_NAME') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.FB.PICK_NAME')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.FB.ADD_NAME') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.pageId.$error }">
        {{ $t('INBOX_MGMT.ADD.FB.MANUAL.PAGE_ID.LABEL') }}
        <input
          v-model="pageId"
          type="text"
          autocomplete="off"
          :placeholder="$t('INBOX_MGMT.ADD.FB.MANUAL.PAGE_ID.PLACEHOLDER')"
          @blur="v$.pageId.$touch"
        />
        <span v-if="v$.pageId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.FB.MANUAL.PAGE_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.pageAccessToken.$error }">
        {{ $t('INBOX_MGMT.ADD.FB.MANUAL.PAGE_TOKEN.LABEL') }}
        <input
          v-model="pageAccessToken"
          type="password"
          autocomplete="off"
          :placeholder="$t('INBOX_MGMT.ADD.FB.MANUAL.PAGE_TOKEN.PLACEHOLDER')"
          @blur="v$.pageAccessToken.$touch"
        />
        <span v-if="v$.pageAccessToken.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.FB.MANUAL.PAGE_TOKEN.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.FB.MANUAL.USER_TOKEN.LABEL') }}
        <input
          v-model="userAccessToken"
          type="password"
          autocomplete="off"
          :placeholder="$t('INBOX_MGMT.ADD.FB.MANUAL.USER_TOKEN.PLACEHOLDER')"
        />
        <span class="mt-1 block text-xs text-n-slate-10">
          {{ $t('INBOX_MGMT.ADD.FB.MANUAL.USER_TOKEN.HINT') }}
        </span>
      </label>
    </div>

    <p class="mb-3 text-xs text-n-slate-10">
      {{ $t('INBOX_MGMT.ADD.FB.MANUAL.INSTAGRAM_NOTE') }}
    </p>

    <div class="mt-2 w-full">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.FB.CREATE_INBOX')"
      />
    </div>
  </form>
</template>
